import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Month } from '../models/month.model';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MonthService {

  constructor(private httpClient: HttpClient) {}

  getMonths() : Observable<Month[]> {
    return this.httpClient.get<Month[]>('assets/components/months/months.json').pipe(
      map(data => data)
    );
  }
}
